import theme from "@monorepo/styles/theme";
import { styled } from "@mui/material";

export const StyledSinglePayment = styled("div", { shouldForwardProp: (prop) => prop !== "isActive" })<{
  isActive: boolean;
}>(({ isActive }) => ({
  borderRadius: 6,
  backgroundColor: isActive ? theme.palette.shuttleGray.main : theme.palette.secondary.main,
  cursor: "pointer",
  boxSizing: "border-box",
  textDecoration: "none !important",
  textDecorationLine: "none",
  overflow: "hidden",
  transition: `background-color ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeOut}`,
  ":hover": {
    transition: `background-color ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeOut}`,
    backgroundColor: theme.palette.azureishWhite.main,
  },
  "& .MuiTypography-body1": {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "100%",
    color: isActive ? theme.palette.secondary.main : theme.palette.text.primary,
    fontSize: theme.typography.body2.fontSize,
    lineHeight: 1.4,
  },
  "& .MuiTypography-body2": {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "100%",
    fontSize: theme.typography.caption.fontSize,
    lineHeight: 1.4,
  },
  "& .MuiIconButton-root": {
    stroke: isActive ? theme.palette.secondary.main : theme.palette.text.primary,
  },
  "& a": {
    padding: "12px 18px",
    color: theme.palette.text.disabled,
    borderBottomColor: "none",
    display: "grid",
    alignItems: "center",
    textDecoration: "none",
    gridTemplateColumns: "auto 1fr auto",
    gridColumnGap: "12px",
  },
}));
